import React, { useState } from 'react';
import './CalculadoraRetenciones.css';

// Base de datos de reglas de retenciones
const REGLAS_RETENCIONES = {
  // Régimen 612 - Personas Físicas con Actividades Empresariales y Profesionales
  '612-601-servicios': {
    regimenEmisor: '612',
    regimenReceptor: '601',
    concepto: 'Prestación de Servicios',
    retieneISR: true,
    porcentajeISR: 10,
    retieneIVA: true,
    porcentajeIVA: 66.67,
    fundamento: 'Art. 106 LISR, Art. 1-A LIVA',
    explicacion: 'Persona Física con Actividades Empresariales prestando servicios a Persona Moral debe aplicar retenciones.'
  },
  '612-601-bienes': {
    regimenEmisor: '612',
    regimenReceptor: '601',
    concepto: 'Venta de Bienes',
    retieneISR: false,
    porcentajeISR: 0,
    retieneIVA: false,
    porcentajeIVA: 0,
    fundamento: 'No aplica retención',
    explicacion: 'La venta de bienes no genera obligación de retención.'
  },
  '612-601-fletes': {
    regimenEmisor: '612',
    regimenReceptor: '601',
    concepto: 'Servicio de Fletes',
    retieneISR: false,
    porcentajeISR: 0,
    retieneIVA: true,
    porcentajeIVA: 25,
    fundamento: 'Art. 1-A LIVA',
    explicacion: 'Servicio de fletes aplica retención de IVA del 4% del IVA trasladado.'
  },
  
  // Régimen 612 con Receptor 626 (RESICO)
  '612-626-servicios': {
    regimenEmisor: '612',
    regimenReceptor: '626',
    concepto: 'Prestación de Servicios',
    retieneISR: true,
    porcentajeISR: 10,
    retieneIVA: true,
    porcentajeIVA: 66.67,
    fundamento: 'Art. 106 LISR, Art. 1-A LIVA',
    explicacion: 'Persona Física con Actividades Empresariales prestando servicios a Régimen Simplificado debe aplicar retenciones.'
  },
  '612-626-bienes': {
    regimenEmisor: '612',
    regimenReceptor: '626',
    concepto: 'Venta de Bienes',
    retieneISR: false,
    porcentajeISR: 0,
    retieneIVA: false,
    porcentajeIVA: 0,
    fundamento: 'No aplica retención',
    explicacion: 'La venta de bienes no genera obligación de retención.'
  },
  '612-626-fletes': {
    regimenEmisor: '612',
    regimenReceptor: '626',
    concepto: 'Servicio de Fletes',
    retieneISR: false,
    porcentajeISR: 0,
    retieneIVA: true,
    porcentajeIVA: 25,
    fundamento: 'Art. 1-A LIVA',
    explicacion: 'Servicio de fletes aplica retención de IVA del 4% del IVA trasladado.'
  },

  // Régimen 626 - Régimen Simplificado de Confianza (RESICO)
  '626-601-servicios': {
    regimenEmisor: '626',
    regimenReceptor: '601',
    concepto: 'Prestación de Servicios',
    retieneISR: true,
    porcentajeISR: 1.25,
    retieneIVA: true,
    porcentajeIVA: 66.67,
    fundamento: 'Art. 113-E LISR, Art. 1-A LIVA',
    explicacion: 'Régimen Simplificado de Confianza prestando servicios a Persona Moral aplica retenciones reducidas.'
  },
  '626-601-bienes': {
    regimenEmisor: '626',
    regimenReceptor: '601',
    concepto: 'Venta de Bienes',
    retieneISR: true,
    porcentajeISR: 1.25,
    retieneIVA: false,
    porcentajeIVA: 0,
    fundamento: 'Art. 113-E LISR',
    explicacion: 'RESICO en venta de bienes solo aplica retención de ISR del 1.25%.'
  },
  '626-601-arrendamiento': {
    regimenEmisor: '626',
    regimenReceptor: '601',
    concepto: 'Arrendamiento de Bienes',
    retieneISR: true,
    porcentajeISR: 1.25,
    retieneIVA: true,
    porcentajeIVA: 10.67,
    fundamento: 'Art. 113-E LISR, Art. 1-A LIVA',
    explicacion: 'RESICO en arrendamiento aplica retenciones de ISR e IVA.'
  },
  '626-601-fletes': {
    regimenEmisor: '626',
    regimenReceptor: '601',
    concepto: 'Servicio de Fletes',
    retieneISR: true,
    porcentajeISR: 1.25,
    retieneIVA: true,
    porcentajeIVA: 25,
    fundamento: 'Art. 113-E LISR, Art. 1-A LIVA',
    explicacion: 'RESICO en servicio de fletes aplica retención de ISR 1.25% y IVA 4%.'
  },

  // Régimen 626 con Receptor 626
  '626-626-servicios': {
    regimenEmisor: '626',
    regimenReceptor: '626',
    concepto: 'Prestación de Servicios',
    retieneISR: true,
    porcentajeISR: 1.25,
    retieneIVA: true,
    porcentajeIVA: 66.67,
    fundamento: 'Art. 113-E LISR, Art. 1-A LIVA',
    explicacion: 'RESICO prestando servicios a otro RESICO aplica retenciones reducidas.'
  },
  '626-626-bienes': {
    regimenEmisor: '626',
    regimenReceptor: '626',
    concepto: 'Venta de Bienes',
    retieneISR: true,
    porcentajeISR: 1.25,
    retieneIVA: false,
    porcentajeIVA: 0,
    fundamento: 'Art. 113-E LISR',
    explicacion: 'RESICO en venta de bienes solo aplica retención de ISR del 1.25%.'
  },
  '626-626-arrendamiento': {
    regimenEmisor: '626',
    regimenReceptor: '626',
    concepto: 'Arrendamiento de Bienes',
    retieneISR: true,
    porcentajeISR: 1.25,
    retieneIVA: true,
    porcentajeIVA: 66.67,
    fundamento: 'Art. 113-E LISR, Art. 1-A LIVA',
    explicacion: 'RESICO en arrendamiento aplica retenciones de ISR e IVA.'
  },
  '626-626-fletes': {
    regimenEmisor: '626',
    regimenReceptor: '626',
    concepto: 'Servicio de Fletes',
    retieneISR: true,
    porcentajeISR: 1.25,
    retieneIVA: true,
    porcentajeIVA: 25,
    fundamento: 'Art. 113-E LISR, Art. 1-A LIVA',
    explicacion: 'RESICO en servicio de fletes aplica retención de ISR 1.25% y IVA 4%.'
  },

  // Régimen 606 - Arrendamiento
  '606-601-arrendamiento': {
    regimenEmisor: '606',
    regimenReceptor: '601',
    concepto: 'Arrendamiento de Bienes',
    retieneISR: true,
    porcentajeISR: 10,
    retieneIVA: true,
    porcentajeIVA: 66.67,
    fundamento: 'Art. 116 LISR, Art. 1-A LIVA',
    explicacion: 'Persona Física en régimen de arrendamiento debe retener ISR 10% e IVA 10.67%.'
  },
  '606-626-arrendamiento': {
    regimenEmisor: '606',
    regimenReceptor: '626',
    concepto: 'Arrendamiento de Bienes',
    retieneISR: true,
    porcentajeISR: 10,
    retieneIVA: true,
    porcentajeIVA: 66.67,
    fundamento: 'Art. 116 LISR, Art. 1-A LIVA',
    explicacion: 'Persona Física en régimen de arrendamiento debe retener ISR 10% e IVA 10.67%.'
  }
};

// Catálogo de regímenes fiscales
const REGIMENES = [
  { value: '612', label: '612 - Personas Físicas con Actividades Empresariales y Profesionales', tipo: 'fisica' },
  { value: '626', label: '626 - Régimen Simplificado de Confianza (RESICO)', tipo: 'fisica' },
  { value: '606', label: '606 - Arrendamiento', tipo: 'fisica' },
  { value: '601', label: '601 - General de Ley Personas Morales', tipo: 'moral' },
  { value: '605', label: '605 - Sueldos y Salarios e Ingresos Asimilados a Salarios', tipo: 'fisica' },
  { value: '608', label: '608 - Demás ingresos', tipo: 'fisica' },
  { value: '610', label: '610 - Residentes en el Extranjero sin Establecimiento Permanente', tipo: 'moral' },
  { value: '611', label: '611 - Ingresos por Dividendos', tipo: 'fisica' },
  { value: '614', label: '614 - Ingresos por intereses', tipo: 'fisica' },
  { value: '615', label: '615 - Régimen de los ingresos por obtención de premios', tipo: 'fisica' },
  { value: '616', label: '616 - Sin obligaciones fiscales', tipo: 'fisica' },
  { value: '620', label: '620 - Sociedades Cooperativas de Producción', tipo: 'moral' },
  { value: '621', label: '621 - Incorporación Fiscal', tipo: 'fisica' },
  { value: '622', label: '622 - Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras', tipo: 'moral' },
  { value: '623', label: '623 - Opcional para Grupos de Sociedades', tipo: 'moral' },
  { value: '624', label: '624 - Coordinados', tipo: 'moral' },
  { value: '625', label: '625 - Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas', tipo: 'fisica' },
  { value: '603', label: '603 - Personas Morales con Fines no Lucrativos', tipo: 'moral' }
];

// Conceptos de facturación
const CONCEPTOS = [
  { value: 'servicios', label: 'Prestación de Servicios' },
  { value: 'bienes', label: 'Venta de Bienes' },
  { value: 'arrendamiento', label: 'Arrendamiento de Bienes' },
  { value: 'fletes', label: 'Servicio de Fletes' }
];

const CalculadoraRetenciones = () => {
  const [regimenEmisor, setRegimenEmisor] = useState('');
  const [regimenReceptor, setRegimenReceptor] = useState('');
  const [concepto, setConcepto] = useState('');
  const [monto, setMonto] = useState('');
  const [resultado, setResultado] = useState(null);

  const calcularRetenciones = () => {
    // Validar campos
    if (!regimenEmisor || !regimenReceptor || !concepto || !monto) {
      alert('Por favor complete todos los campos');
      return;
    }

    const montoNum = parseFloat(monto);
    if (isNaN(montoNum) || montoNum <= 0) {
      alert('Por favor ingrese un monto válido');
      return;
    }

    // REGLA PRINCIPAL: Si el receptor es Persona Física, NO hay retenciones
    const receptorData = REGIMENES.find(r => r.value === regimenReceptor);
    if (receptorData && receptorData.tipo === 'fisica') {
      setResultado({
        subtotal: montoNum,
        iva: montoNum * 0.16,
        total: montoNum * 1.16,
        retencionISR: 0,
        retencionIVA: 0,
        totalAPagar: montoNum * 1.16,
        sinRetenciones: true,
        explicacion: 'No se aplican retenciones porque el receptor es Persona Física. Las retenciones solo aplican cuando el receptor es Persona Moral.'
      });
      return;
    }

    // Buscar la regla correspondiente
    const claveRegla = `${regimenEmisor}-${regimenReceptor}-${concepto}`;
    const regla = REGLAS_RETENCIONES[claveRegla];

    if (!regla) {
      setResultado({
        subtotal: montoNum,
        iva: montoNum * 0.16,
        total: montoNum * 1.16,
        retencionISR: 0,
        retencionIVA: 0,
        totalAPagar: montoNum * 1.16,
        sinRegla: true,
        explicacion: 'No existe una regla específica para esta combinación. Por favor consulte con su contador.'
      });
      return;
    }

    // Calcular retenciones
    const iva = montoNum * 0.16;
    const total = montoNum + iva;
    
    const retencionISR = regla.retieneISR ? (montoNum * regla.porcentajeISR / 100) : 0;
    const retencionIVA = regla.retieneIVA ? (iva * (2/3)) : 0;
    
    const totalAPagar = total - retencionISR - retencionIVA;

    setResultado({
      subtotal: montoNum,
      iva: iva,
      total: total,
      retencionISR: retencionISR,
      retencionIVA: retencionIVA,
      totalAPagar: totalAPagar,
      porcentajeISR: regla.porcentajeISR,
      porcentajeIVA: regla.porcentajeIVA,
      retieneISR: regla.retieneISR,
      retieneIVA: regla.retieneIVA,
      fundamento: regla.fundamento,
      explicacion: regla.explicacion
    });
  };

  const formatMoney = (value) => {
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN'
    }).format(value);
  };

  const limpiarFormulario = () => {
    setRegimenEmisor('');
    setRegimenReceptor('');
    setConcepto('');
    setMonto('');
    setResultado(null);
  };

  return (
    <div className="calculadora-container">
      <div className="calculadora-header">
        <h2>🧮 Calculadora de Retenciones</h2>
        <p>Calcula las retenciones de ISR e IVA de acuerdo a las disposiciones fiscales vigentes</p>
      </div>

      <div className="calculadora-form">
        <div className="form-group">
          <label>Régimen Fiscal del Emisor (quien factura):</label>
          <select 
            value={regimenEmisor} 
            onChange={(e) => setRegimenEmisor(e.target.value)}
            className="form-select"
          >
            <option value="">Seleccione un régimen...</option>
            {REGIMENES.map(reg => (
              <option key={reg.value} value={reg.value}>{reg.label}</option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label>Régimen Fiscal del Receptor (quien recibe factura):</label>
          <select 
            value={regimenReceptor} 
            onChange={(e) => setRegimenReceptor(e.target.value)}
            className="form-select"
          >
            <option value="">Seleccione un régimen...</option>
            {REGIMENES.map(reg => (
              <option key={reg.value} value={reg.value}>{reg.label}</option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label>Concepto de Facturación:</label>
          <select 
            value={concepto} 
            onChange={(e) => setConcepto(e.target.value)}
            className="form-select"
          >
            <option value="">Seleccione un concepto...</option>
            {CONCEPTOS.map(conc => (
              <option key={conc.value} value={conc.value}>{conc.label}</option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label>Monto antes de IVA (Subtotal):</label>
          <input 
            type="number" 
            value={monto}
            onChange={(e) => setMonto(e.target.value)}
            placeholder="0.00"
            className="form-input"
            step="0.01"
            min="0"
          />
        </div>

        <div className="form-buttons">
          <button onClick={calcularRetenciones} className="btn-calcular">
            Calcular Retenciones
          </button>
          <button onClick={limpiarFormulario} className="btn-limpiar">
            Limpiar
          </button>
        </div>
      </div>

      {resultado && (
        <div className="resultado-container">
          <h3>📊 Resultado del Cálculo</h3>
          
          <div className="resultado-desglose">
            <div className="desglose-item">
              <span>Subtotal:</span>
              <span className="valor">{formatMoney(resultado.subtotal)}</span>
            </div>
            <div className="desglose-item">
              <span>IVA (16%):</span>
              <span className="valor">{formatMoney(resultado.iva)}</span>
            </div>
            <div className="desglose-separator"></div>
            <div className="desglose-item total">
              <span>Total:</span>
              <span className="valor">{formatMoney(resultado.total)}</span>
            </div>
          </div>

          {resultado.sinRetenciones ? (
            <div className="alerta-info">
              <span className="icono">ℹ️</span>
              <p><strong>Sin Retenciones</strong></p>
              <p>{resultado.explicacion}</p>
            </div>
          ) : resultado.sinRegla ? (
            <div className="alerta-warning">
              <span className="icono">⚠️</span>
              <p><strong>Regla No Encontrada</strong></p>
              <p>{resultado.explicacion}</p>
            </div>
          ) : (
            <>
              <div className="retenciones-detalle">
                <h4>Retenciones a Aplicar:</h4>
                
                {resultado.retieneISR ? (
                  <div className="retencion-item retencion-si">
                    <span className="icono">✅</span>
                    <div className="retencion-info">
                      <strong>Retención de ISR:</strong>
                      <span>{resultado.porcentajeISR}% del subtotal = {formatMoney(resultado.retencionISR)}</span>
                    </div>
                  </div>
                ) : (
                  <div className="retencion-item retencion-no">
                    <span className="icono">❌</span>
                    <div className="retencion-info">
                      <strong>Retención de ISR:</strong>
                      <span>No aplica</span>
                    </div>
                  </div>
                )}

                {resultado.retieneIVA ? (
                  <div className="retencion-item retencion-si">
                    <span className="icono">✅</span>
                    <div className="retencion-info">
                      <strong>Retención de IVA:</strong>
                      <span>{resultado.porcentajeIVA}% del IVA trasladado = {formatMoney(resultado.retencionIVA)}</span>
                    </div>
                  </div>
                ) : (
                  <div className="retencion-item retencion-no">
                    <span className="icono">❌</span>
                    <div className="retencion-info">
                      <strong>Retención de IVA:</strong>
                      <span>No aplica</span>
                    </div>
                  </div>
                )}
              </div>

              <div className="resultado-final">
                <div className="total-pagar">
                  <span>💰 Total a Pagar:</span>
                  <span className="monto-final">{formatMoney(resultado.totalAPagar)}</span>
                </div>
              </div>

              <div className="fundamento-legal">
                <h4>📝 Fundamento Legal:</h4>
                <p><strong>{resultado.fundamento}</strong></p>
                <p>{resultado.explicacion}</p>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default CalculadoraRetenciones;
